import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Form from './clienteForm';
import Aguardando from '../common/template/aguardando';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';
import FormatUtils from '../common/formatUtils/FormatUtils';

import {
    setModoTela,
    initForm,
    salvar,
    excluir,
    getLista
} from './clienteActions';

import {
    getLista as getListaCidade
} from '../cidade/cidadeActions';

import {
    getLista as getListaUsuario
} from '../usuario/usuarioActions';


const columns = [
    { field: 'razao_social', type: 'text' },
    { field: 'cpf_cnpj', type: 'text', formatter: row => row.cpf || row.cnpj },
    { field: 'nome_cidade', type: 'text' },
    { field: 'area_total', type: 'number' }
];

const formatarHectares = valor =>
    `${FormatUtils.formatarValorTela(valor || 0, 2)} ha`;

const Cliente = props => {

    const [linhaSelecionada, setLinhaSelecionada] = useState(null);
    const [pesquisar, setPesquisar] = useState('');
    const [sort, setSort] = useState({
        field: 'razao_social',
        direction: 'asc'
    });

    useEffect(() => {
        props.getLista();
        props.getListaCidade();
        props.getListaUsuario();
    }, []);

    const onSort = field => {
        setSort(prev => {
            let direction = 'asc';

            if (prev.field === field) {
                direction = prev.direction === 'asc' ? 'desc' : 'asc';
            }

            return { field, direction };
        });
    };

    const filtrar = () => {
        const termoPesquisa = (pesquisar || '').trim();

        const listaFiltrada = (props.lista || []).filter(item => {
            if (!termoPesquisa) {
                return true;
            }

            const texto = `
                ${item.razao_social || ''}
                ${item.nome_fantasia || ''}
                ${item.cpf || ''}
                ${item.cnpj || ''}
                ${item.nome_cidade || ''}
                ${item.referencia || ''}
                ${formatarHectares(item.area_total)}
            `.toUpperCase();

            return termoPesquisa
                .toUpperCase()
                .split('+')
                .filter(p => p.trim())
                .every(p => texto.includes(p.trim()));
        });

        return sortData(listaFiltrada, sort, columns);
    };

    const montarExcel = lista => {
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        return (
            <ExcelSheet
                data={lista.map(item => ({
                    ...item,
                    contatos_formatado: (item.contatos || [])
                        .map(contato => [
                            contato.nome,
                            contato.celular,
                            contato.email
                        ].filter(Boolean).join(' - '))
                        .join(' | '),
                    ids_consultores_formatado:
                        (item.ids_consultores || []).join(', '),
                    area_total_formatada:
                        formatarHectares(item.area_total)
                }))}
                name='Clientes'
            >
                <ExcelColumn label='Razão Social' value='razao_social' />
                <ExcelColumn label='Nome Fantasia' value='nome_fantasia' />
                <ExcelColumn label='CNPJ' value='cnpj' />
                <ExcelColumn label='CPF' value='cpf' />
                <ExcelColumn label='IE' value='ie' />
                <ExcelColumn label='Endereço' value='endereco' />
                <ExcelColumn label='Referência' value='referencia' />
                <ExcelColumn label='CEP' value='cep' />
                <ExcelColumn label='Cidade' value='nome_cidade' />
                <ExcelColumn label='Área Total' value='area_total_formatada' />
                <ExcelColumn label='Latitude' value='latitude' />
                <ExcelColumn label='Longitude' value='longitude' />
                <ExcelColumn label='Contatos' value='contatos_formatado' />
                <ExcelColumn label='Consultores' value='ids_consultores_formatado' />
                <ExcelColumn label='Usuário da Inclusão' value='nome_usuario_inclusao' />
                <ExcelColumn label='Usuário da Alteração' value='nome_usuario_alteracao' />
            </ExcelSheet>
        );
    };

    const renderLista = () => {
        const ExcelFile = ReactExport.ExcelFile;
        const lista = filtrar();

        const alturaTabela = window.innerWidth < 631
            ? window.innerHeight - 260
            : window.innerHeight - 180;

        return (
            <ContentCard>
                <ContentCardHeader>
                    <Row>
                        <InputPesquisa
                            cols='12 6 3 1'
                            label='Pesquisar'
                            minWidth={344}
                            onChange={value => setPesquisar(value)}
                        />

                        <div>
                            <button
                                type='button'
                                className='btn btn-app bg-success'
                                style={{ marginLeft: 2, minWidth: 75 }}
                                onClick={() => {
                                    props.setModoTela('cadastro', {});
                                    props.initForm({
                                        tipo_pessoa: 'juridica',
                                        contatos: [
                                            {
                                                id: null,
                                                nome: '',
                                                celular: '',
                                                email: ''
                                            }
                                        ]
                                    });
                                }}
                            >
                                <i className='fas fa-plus'></i> Adicionar
                            </button>

                            <button
                                type='button'
                                className='btn btn-app bg-primary'
                                style={{ marginLeft: 2, minWidth: 75 }}
                                onClick={() => props.getLista()}
                            >
                                <i className='fas fa-sync-alt'></i> Atualizar
                            </button>

                            <ExcelFile
                                filename='Clientes'
                                element={
                                    <button
                                        type='button'
                                        className='btn btn-app bg-info'
                                        style={{ marginLeft: 2, minWidth: 75 }}
                                    >
                                        <i className='fas fa-file-excel'></i> Exportar
                                    </button>
                                }
                            >
                                {montarExcel(lista)}
                            </ExcelFile>
                        </div>
                    </Row>
                </ContentCardHeader>

                <ContentCardBody>
                    <Table
                        responsive
                        border
                        alturaFixa
                        striped
                        maxHeight={alturaTabela}
                    >
                        <THead>
                            <Tr>
                                <ThSort
                                    field='razao_social'
                                    label='Razão Social'
                                    width={300}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='cpf_cnpj'
                                    label='CPF / CNPJ'
                                    width={150}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='nome_cidade'
                                    label='Cidade'
                                    width={200}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='area_total'
                                    label='Área Total'
                                    width={130}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <Th sticky alignCenter width={50}></Th>
                            </Tr>
                        </THead>

                        <TBody>
                            {lista.map((item, i) => (
                                <Tr
                                    key={item.id}
                                    backgroundColor={
                                        linhaSelecionada === item.id
                                            ? '#bcc7eb'
                                            : i % 2 === 0
                                                ? '#ffffff'
                                                : '#f5f5f5'
                                    }
                                >
                                    <Td onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter>
                                        {item.razao_social}
                                    </Td>

                                    <Td
                                        onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {item.cpf || item.cnpj}
                                    </Td>

                                    <Td
                                        onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {item.nome_cidade}
                                    </Td>

                                    <Td
                                        onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {formatarHectares(item.area_total)}
                                    </Td>

                                    <Td alignCenter minWidth={165} maxWidth={165}>
                                        <ButtonTable
                                            type='warning'
                                            width={32}
                                            small
                                            icon='fas fa-pencil-alt'
                                            visible
                                            title='Editar'
                                            event={() => {
                                                props.setModoTela('cadastro', { ...item });
                                                props.initForm({ ...item });
                                            }}
                                        />

                                        <ButtonTable
                                            type='danger'
                                            width={32}
                                            small
                                            icon='fas fa-trash-alt'
                                            visible
                                            title='Excluir'
                                            event={() => {
                                                props.setModoTela('exclusao', { ...item });
                                                props.initForm({ ...item });
                                            }}
                                        />
                                    </Td>
                                </Tr>
                            ))}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    };

    return (
        <Content>
            <Aguardando aguardando={props.aguardando} />

            {props.modoTela === 'cadastro' &&
                <Form onSubmit={props.salvar} />}

            {props.modoTela === 'exclusao' &&
                <Form excluir onSubmit={props.excluir} />}

            {props.modoTela === 'lista' &&
                renderLista()}
        </Content>
    );
};

const mapStateToProps = state => ({
    sessao: state.auth.usuario,
    modoTela: state.cliente.modoTela,
    aguardando: state.cliente.aguardando,
    lista: state.cliente.lista,
    registro: state.cliente.registro
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoTela,
    initForm,
    salvar,
    excluir,
    getLista,
    getListaCidade,
    getListaUsuario
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Cliente);
